(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"]) return;
  try {
    
  (function(){
    var d = document,
    accordionToggles = d.querySelectorAll('.js-accordionTrigger'),
    setAria,
    setAccordionAria,
    switchAccordion,
    touchSupported = ('ontouchstart' in window),
    pointerSupported = ('pointerdown' in window);

    skipClickDelay = function(e){
      e.preventDefault();
      e.target.click();
    }

      setAriaAttr = function(el, ariaType, newProperty){
      el.setAttribute(ariaType, newProperty);
    };
    setAccordionAria = function(el1, el2, expanded){
      switch(expanded) {
        case "true":
          setAriaAttr(el1, 'aria-expanded', 'true');
          setAriaAttr(el2, 'aria-hidden', 'false');
          break;
        case "false":
          setAriaAttr(el1, 'aria-expanded', 'false');
          setAriaAttr(el2, 'aria-hidden', 'true');
          break;
        default:
          break;
      }
    };

    switchAccordion = function(e) {
      e.preventDefault();
      var thisAnswer = e.target.parentNode.nextElementSibling;
      var thisQuestion = e.target;
      if(thisAnswer.classList.contains('is-collapsed')) {
        setAccordionAria(thisQuestion, thisAnswer, 'true');
      } else {
        setAccordionAria(thisQuestion, thisAnswer, 'false');
      }
      thisQuestion.classList.toggle('is-collapsed');
      thisQuestion.classList.toggle('is-expanded');
      thisAnswer.classList.toggle('is-collapsed');
      thisAnswer.classList.toggle('is-expanded');

      thisAnswer.classList.toggle('animateIn');
    };
    for (var i=0,len=accordionToggles.length; i<len; i++) {
      if(touchSupported) {
        accordionToggles[i].addEventListener('touchstart', skipClickDelay, false);
      }
      if(pointerSupported){
        accordionToggles[i].addEventListener('pointerdown', skipClickDelay, false);
      }
      accordionToggles[i].addEventListener('click', switchAccordion, false);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayhem130-product-template"]) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-simple"]) return;
  try {
    
  $(document).ready(function(){
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !window.DesignMode) return;
  try {
    
  function review_check(num) {
    var j = parseInt(num);
    if($('.spr-reviews .spr-review').length > 0) {
      $('i').changeElementType('em');
    } else {
      if(j < 20) {
        j = num + 1;
        setTimeout(function(){review_check(j)}, 1000);
      }
    }
  }
  $(document).ready(function(){
    review_check(1);
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
